import { parse } from 'date-fns'

import { ApiGetResponse, ApiRequest } from 'app/common/types'
import { ConnectionName } from 'app/connections/types'

interface DatePeriodGetContent {
  fromDate: string
  toDate: string
}

interface SessionsEntity {
  date: string
  sessionCount: number
  sessionCount30DaysBefore: number
  sessionsWithTreatmentsByConnection: Record<ConnectionName, number>
}

export type SessionsGetRequest = ApiRequest<DatePeriodGetContent>
export type SessionsResponse = ApiGetResponse<SessionsEntity[]>

export type AudienceDayRevenue = {
  id: string
  name: string
  revenue: number
}

export type DaySessions = {
  date: Date
  total: number
  total30DaysBefore: number
  connections: Record<ConnectionName, number>
}

const mapToSession = (sessionEntity: SessionsEntity): DaySessions => ({
  date: parse(sessionEntity.date, 'yyyy-MM-dd', new Date()),
  total: sessionEntity.sessionCount,
  total30DaysBefore: sessionEntity.sessionCount30DaysBefore,
  connections: sessionEntity.sessionsWithTreatmentsByConnection,
})

export const mapToSortedSessions = (sessionEntities: SessionsEntity[]): DaySessions[] =>
  sessionEntities.map(mapToSession).sort((a, b) => b.date.getTime() - a.date.getTime())
